import * as Sentry from "@sentry/browser";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
// このファイル内でパッケージ向けに特化した useSelector を再定義するため
// eslint-disable-next-line no-restricted-imports
import { useSelector as useReduxSelector } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";

import reducers from "../modules";
import indexSaga from "../modules/indexSaga";

import type { TypedUseSelectorHook } from "react-redux";

export const history = createBrowserHistory();

export type Store = ReturnType<typeof store.getState>;
const sagaMiddleware = createSagaMiddleware({
  onError(err) {
    Sentry.captureException(err);
  },
});

const loggerMiddleware = createLogger({
  // omit redux-logger
  predicate: () => process.env.NODE_ENV === "development" && false,
});

const store = createStore(
  reducers(history),
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, loggerMiddleware, routerMiddleware(history))
  )
);
sagaMiddleware.run(indexSaga);

/**
 * @description
 * legacy/portal 向けに callback の store が最適化された useSelector
 * callback の store に型注釈する必要がありません
 */
export const useSelector: TypedUseSelectorHook<Store> = useReduxSelector;

export default store;
